/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type UtilizationReportTotals_viewer$ref: FragmentReference;
declare export opaque type UtilizationReportTotals_viewer$fragmentType: UtilizationReportTotals_viewer$ref;
export type UtilizationReportTotals_viewer = {|
  +company: ?{|
    +companyTarget: ?number,
    +isUsingProjectAllocation: ?boolean,
    +resourceNumbers: ?{|
      +actualBillableProjectMinutes: ?number,
      +actualNonBillableProjectMinutes: ?number,
      +actualInternalMinutes: ?number,
      +actualTotalMinutes: ?number,
      +actualOverMinutes: ?number,
      +actualDoneTaskMinutes: ?number,
      +actualBillableUtilization: ?number,
      +actualNonBillableUtilization: ?number,
      +actualInternalUtilization: ?number,
      +actualResourceUtilization: ?number,
      +plannedBillableProjectMinutes: ?number,
      +plannedNonBillableProjectMinutes: ?number,
      +plannedInternalMinutes: ?number,
      +plannedTotalMinutes: ?number,
      +plannedOverMinutes: ?number,
      +plannedDoneTaskMinutes: ?number,
      +plannedBillableUtilization: ?number,
      +plannedNonBillableUtilization: ?number,
      +plannedInternalUtilization: ?number,
      +plannedResourceUtilization: ?number,
      +billableActualVsPlan: ?number,
      +nonBillableActualVsPlan: ?number,
      +internalActualVsPlan: ?number,
      +totalActualVsPlan: ?number,
      +remainingBillableProjectMinutes: ?number,
      +remainingNonBillableProjectMinutes: ?number,
      +remainingInternalMinutes: ?number,
      +remainingTotalMinutes: ?number,
      +remainingOverMinutes: ?number,
      +remainingBillableUtilization: ?number,
      +remainingNonBillableUtilization: ?number,
      +remainingInternalUtilization: ?number,
      +remainingResourceUtilization: ?number,
      +forecastBillableProjectMinutes: ?number,
      +forecastNonBillableProjectMinutes: ?number,
      +forecastInternalMinutes: ?number,
      +forecastTotalMinutes: ?number,
      +forecastOverMinutes: ?number,
      +forecastBillableUtilization: ?number,
      +forecastNonBillableUtilization: ?number,
      +forecastInternalUtilization: ?number,
      +forecastResourceUtilization: ?number,
      +workingMinutes: ?number,
      +timeOffMinutes: ?number,
      +availableMinutes: ?number,
      +performance: ?number,
    |},
    +aggregatedResourceNumbersByDay: $ReadOnlyArray<?string>,
    +aggregatedResourceNumbersByMonth: $ReadOnlyArray<?string>,
  |},
  +$refType: UtilizationReportTotals_viewer$ref,
|};
export type UtilizationReportTotals_viewer$data = UtilizationReportTotals_viewer;
export type UtilizationReportTotals_viewer$key = {
  +$data?: UtilizationReportTotals_viewer$data,
  +$fragmentRefs: UtilizationReportTotals_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "Variable",
  "name": "endDay",
  "variableName": "endDay"
},
v1 = {
  "kind": "Variable",
  "name": "endMonth",
  "variableName": "endMonth"
},
v2 = {
  "kind": "Variable",
  "name": "endYear",
  "variableName": "endYear"
},
v3 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v4 = {
  "kind": "Variable",
  "name": "startDay",
  "variableName": "startDay"
},
v5 = {
  "kind": "Variable",
  "name": "startMonth",
  "variableName": "startMonth"
},
v6 = {
  "kind": "Variable",
  "name": "startYear",
  "variableName": "startYear"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery",
      "type": "TaskSearchQueryType!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDay",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endYear",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endMonth",
      "type": "Int!"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "endDay",
      "type": "Int!"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "UtilizationReportTotals_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "companyTarget",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isUsingProjectAllocation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "concreteType": "ResourceNumbers",
          "kind": "LinkedField",
          "name": "resourceNumbers",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualNonBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualInternalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualTotalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualOverMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualDoneTaskMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualNonBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualInternalUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "actualResourceUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedNonBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedInternalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedTotalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedOverMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedDoneTaskMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedNonBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedInternalUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "plannedResourceUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "billableActualVsPlan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "nonBillableActualVsPlan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "internalActualVsPlan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalActualVsPlan",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingNonBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingInternalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingTotalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingOverMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingNonBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingInternalUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingResourceUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastNonBillableProjectMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastInternalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastTotalMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastOverMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastNonBillableUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastInternalUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "forecastResourceUtilization",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workingMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timeOffMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "availableMinutes",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "performance",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "aggregatedResourceNumbersByDay",
          "args": [
            {
              "kind": "Literal",
              "name": "aggregateLevel",
              "value": "DAY"
            },
            {
              "kind": "Literal",
              "name": "aggregates",
              "value": [
                "availableMinutes",
                "forecastBillableProjectMinutes",
                "forecastTotalMinutes"
              ]
            },
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "aggregatedResourceNumbers",
          "storageKey": null
        },
        {
          "alias": "aggregatedResourceNumbersByMonth",
          "args": [
            {
              "kind": "Literal",
              "name": "aggregateLevel",
              "value": "MONTH"
            },
            {
              "kind": "Literal",
              "name": "aggregates",
              "value": [
                "forecastBillableUtilization",
                "forecastResourceUtilization"
              ]
            },
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "aggregatedResourceNumbers",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = '90ec90b010d090606a0b060976804042';

module.exports = node;
